export const LOGIN_ACTION = 'LOGIN_ACTION';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';